var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "button flex justify-center items-center focus:outline-none",
      class: _vm.iconClasses,
      attrs: { type: "button" },
      on: { click: _vm.toggleFavoriteState },
    },
    [
      !_vm.didLike
        ? _c(
            "button",
            {
              on: {
                click: _vm.toggleFavoriteState,
                mouseover: function ($event) {
                  _vm.isHovered = true
                },
                mouseout: function ($event) {
                  _vm.isHovered = false
                },
              },
            },
            [
              !_vm.isHovered
                ? _c("LikeIcon", { staticClass: "h-4 w-4" })
                : _vm._e(),
              _vm.isHovered
                ? _c("UnlikeIcon", { staticClass: "h-4 w-4" })
                : _vm._e(),
            ],
            1
          )
        : _c(
            "button",
            { on: { click: _vm.toggleFavoriteState } },
            [_c("UnlikeIcon", { staticClass: "h-4 w-4" })],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }